import { E_OFFICE_PREFIX_URL } from '../../e-office-layout/constants/config.e-office-layout'

export const PHAN_BO_TRANG_THIET_BI_SHORT_PREFIX_URL = '/phan-bo-trang-thiet-bi'
export const PHAN_BO_TRANG_THIET_BI_PREFIX_URL = `${E_OFFICE_PREFIX_URL}${PHAN_BO_TRANG_THIET_BI_SHORT_PREFIX_URL}`
